import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription
} from '@ui/dialog.tsx';
import { CreateCompanyForm } from './create-company-form.tsx';
import { useTranslation } from 'react-i18next';
import type { FC } from 'react';

interface CreateNewCompanyDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
}

export const CreateNewCompanyDialog: FC<CreateNewCompanyDialogProps> = ({
  isOpen,
  onOpenChange
}) => {
  const { t } = useTranslation();
  const handleSuccess = () => {
    onOpenChange(false);
  };

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="p-14 max-w-2xl max-h-[90vh] overflow-y-auto scrollable">
        <DialogHeader>
          <DialogTitle className="text-2xl">{t('company.create.dialog.title')}</DialogTitle>
          <DialogDescription>{t('company.create.dialog.description')}</DialogDescription>
        </DialogHeader>

        <div className="mt-6">
          <CreateCompanyForm onSuccess={handleSuccess} />
        </div>
      </DialogContent>
    </Dialog>
  );
};
